import React from "react";
import HeadingProps from "./Heading.types";
import StyledHeading from "./Heading.styles";

/**
 * BW Heading component.
 */
const Heading: React.FC<HeadingProps> = ({ children, variant, ...rest }) => (
    <StyledHeading as={variant} variant={variant} {...rest}>
        {children}
    </StyledHeading>
);

Heading.defaultProps = {
    weight: 400,
    color: "white.100"
};

export default Heading;
